import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { StaticImage } from 'gatsby-plugin-image';
import '../../sass/components/flexibleModules/_components.internalReviewsCarouselSection.scss';
import "../../sass/slick/slick.min.scss";
import "../../sass/slick/slick-theme.min.scss";
import videoPlayButton from '../../images/icon-video-play-button.svg';

const InternalReviewsCarouselSection = ({ data }) => {

    const [isRendered, setIsRendered] = useState(false);

    let settings = {
        dots: true,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        draggable: false,
        centerMode: true,
        swipeToSlide: true,
        centerPadding: '60px 16px 0',
        touchThreshold: 250,
        responsive: [
            {
                breakpoint: 980,
                settings: {
                    slidesToShow: 2,
                    centerPadding: '40px',
                }
            },
            {
                breakpoint: 620,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                    centerPadding: '0',
                }
            }
        ]
    };

    useEffect(() => {
        setIsRendered(true);
    }, []);

    const [videoShow, setVideoShow] = useState(false);
    const [videoShowIndex, setVideoShowIndex] = useState(null);
    const showVideo = (val, valindex) => {
        setVideoShow(val);
        setVideoShowIndex(valindex);
    }

    return (
        <div className={`cp-internalReviewsCarouselSection l-videoCheck${videoShow} ${data.overrideClass ? data.overrideClass : "l-noOverride"}`} style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-internalReviewsCarouselSection__inner" style={{ maxWidth: `${data.maxWidth ? (data.maxWidth / 16 + "rem") : ""}`, margin: "0 auto" }}>
                {isRendered &&
                    <Slider {...settings}>
                        {data.customerReviewsCarouselRepeaterItems.map((carouselItem, index) => (
                            <div className="cp-contentCarousel" key={index}>
                                <div className="cp-contentCarousel__inner">
                                    {carouselItem.wistiavideoid ?
                                        <>
                                            <button onClick={() => showVideo(true, carouselItem.wistiavideoid)} className="l-button l--flex">
                                                <div className="l-relative">
                                                    <span className="l-absolute"><img loading="lazy" src={videoPlayButton} alt="" /></span>
                                                    {carouselItem.image &&
                                                        <GatsbyImage image={getImage(carouselItem.image.gatsbyImage)} alt={carouselItem.image.altText} />
                                                    }
                                                </div>
                                            </button>
                                        </>
                                        :
                                        <>
                                            {carouselItem.image &&
                                                <GatsbyImage image={getImage(carouselItem.image.gatsbyImage)} alt={carouselItem.image.altText} />
                                            }
                                        </>
                                    }
                                    <div className="cp-contentCarousel__inner-text">
                                        <div className="l--overlay">
                                            {carouselItem.reviewerName &&
                                                <h5 dangerouslySetInnerHTML={{ __html: carouselItem.reviewerName }} />
                                            }
                                            {carouselItem.reviewerTitle &&
                                                <p dangerouslySetInnerHTML={{ __html: carouselItem.reviewerTitle }} />
                                            }
                                        </div>
                                        {carouselItem.reviewText &&
                                            <p dangerouslySetInnerHTML={{ __html: carouselItem.reviewText }} />
                                        }
                                    </div>
                                </div>
                            </div>
                        ))}
                        {videoShow &&
                            <div className="cp-wistiaVideo" data-video={videoShowIndex}>
                                <div className={`wistia_embed wistia_async_${videoShowIndex}`}>&nbsp;</div>
                                <button className="cp-wistiaVideo__close" onClick={() => showVideo(false, -1)}>
                                    <StaticImage src="../../images/cross-Icon.svg" alt=""></StaticImage>
                                </button>
                            </div>
                        }
                    </Slider>
                }
            </div>
        </div>
    );
}

export default InternalReviewsCarouselSection;